import './flexgrid.less';
import classNames from 'classnames';

export interface FlexGridOptions {
  xs?: number;
  xm?: number;
  md?: number;
  lg?: number;
  xl?: number;
}

export function getFlexGridClasses({ xs, xm, md, lg, xl }: FlexGridOptions): string {
  if (xs && xs > 12) xs = 12;
  if (xm && xm > 12) xm = 12;
  if (md && md > 12) md = 12;
  if (lg && lg > 12) lg = 12;
  if (xl && xl > 12) xl = 12;

  if (xs && xs < 0) xs = 0;
  if (xm && xm < 0) xm = 0;
  if (md && md < 0) md = 0;
  if (lg && lg < 0) lg = 0;
  if (xl && xl < 0) xl = 0;

  return classNames('', {
    [`col-xs-${xs}`]: !!xs,
    [`col-xm-${xm}`]: !!xm,
    [`col-md-${md}`]: !!md,
    [`col-lg-${lg}`]: !!lg,
    [`col-xl-${xl}`]: !!xl,
  });
}
